import styled from "styled-components";

export const SectionLearnAboutOurProgramContainer = styled.section(
  ({ theme }) => ({
    backgroundColor: theme.color.brandPrimary.light,
    color: theme.color.neutral["08"],
    marginTop: "40px",

    [theme.breakpoint.lg()]: {
      marginTop: "80px",
    },
  })
);

export const SectionLearnAboutOurProgramContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
    paddingTop: "80px",
    paddingBottom: "80px",
  },
}));

export const SectionLearnAboutOurProgramBlock = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const SectionLearnAboutOurProgramBlockTitle = styled.h2(({ theme }) => ({
  fontSize: "32px",
  margin: 0,
  lineHeight: "150%",

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionLearnAboutOurProgramBlockDescription = styled.p(
  ({ theme }) => ({
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "160%",

    [theme.breakpoint.lg()]: {
      fontSize: "20px",
    },
  })
);

export const SectionLearnAboutOurProgramActions = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "16px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },

  button: {
    maxWidth: "100%",
    width: "100%",
    borderRadius: "8px",
    padding: "16px 36px",
    fontWeight: "700",

    [theme.breakpoint.lg()]: {
      width: "auto",
    },

    "&.primary": {
      background: theme.color.brandSecondary.light,
    },

    "&.outlined": {
      borderColor: theme.color.neutral["08"],
      color: theme.color.neutral["08"],
    },
  },
}));
